import { render, staticRenderFns } from "./Ingredent.vue?vue&type=template&id=616934f9&scoped=true&"
import script from "./Ingredent.vue?vue&type=script&lang=js&"
export * from "./Ingredent.vue?vue&type=script&lang=js&"
import style0 from "./Ingredent.vue?vue&type=style&index=0&id=616934f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616934f9",
  null
  
)

export default component.exports